import { Injectable } from '@angular/core';
import { ISessionStorageProvider, SessionStorageService } from '../../../gamma/sessionstorage/sessionstorage.service';

@Injectable()
export class U2000_SessionStorageProvider implements ISessionStorageProvider {
    service: SessionStorageService;
}
